module.exports = [{
      plugin: require('/Users/coles/Documents/brett/react/ddg/node_modules/gatsby-plugin-offline/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('/Users/coles/Documents/brett/react/ddg/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
